export const rates = [
  {
    'plan_id': 47,
    'plan_name': 'Безкоштовне розміщення вакансій керівників',
    'amount': 0,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Months',
    'slug': 'bezlimitne-rozmishtennia-dlia-c-level-ta-kerivnykiv',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 1 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 міс.',
      },
    ],
  },
  {
    'plan_id': 48,
    'plan_name': 'Вакансія Стандарт (1шт.)',
    'amount': 540,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Months',
    'slug': 'vakansiia-standart-1sht',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>1</b> Публ. вакансій',
        'inner': 'Ви можете публікувати 1 вакансій за 1 міс.',
      },
    ],
  },
  {
    'plan_id': 43,
    'plan_name': 'Вакансія з прямим відгуком (1шт.)',
    'amount': 890,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Months',
    'slug': 'direct-response',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>1</b> Публ. вакансій',
        'inner': 'Ви можете публікувати 1 вакансій за 1 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 міс.',
      },
    ],
  },
  {
    'plan_id': 44,
    'plan_name': 'Для публікації вакансій (5шт.)',
    'amount': 4228,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Months',
    'slug': 'vacancy-posting-with-additional-promo-5',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>5</b> Публ. вакансій',
        'inner': 'Ви можете публікувати 5 вакансій за 1 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 міс.',
      },
    ],
  },
  {
    'plan_id': 46,
    'plan_name': 'Безлімітне розміщення вакансій (1 місяць)',
    'amount': 19900,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Months',
    'slug': 'bezlimit-promo-1-misiacj',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 1 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 міс.',
      },
    ],
  },
  {
    'plan_id': 49,
    'plan_name': 'Безлімітне розміщення вакансій (3 місяці)',
    'amount': 56715,
    'currency': 'UAH',
    'plan_type': 3,
    'plan_type_value': 'Months',
    'slug': 'bezlimitne-rozmishtennia-vakansij-3-misiaci',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 3 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 3 міс.',
      },
    ],
  },
  {
    'plan_id': 50,
    'plan_name': 'Безлімітне розміщення вакансій (6 місяців)',
    'amount': 107460,
    'currency': 'UAH',
    'plan_type': 6,
    'plan_type_value': 'Months',
    'slug': 'bezlimitne-rozmishtennia-vakansij-6-misiaciv',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 6 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 6 міс.',
      },
    ],
  },
  {
    'plan_id': 51,
    'plan_name': 'Безліміт вакансій з бренд сторінкою (6_місяців)',
    'amount': 137460,
    'currency': 'UAH',
    'plan_type': 6,
    'plan_type_value': 'Months',
    'slug': 'bezlimit-vakansij-6-misiaciv-z-brend-storinkoyu',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 6 міс.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 6 міс.',
      },
    ],
  },
  {
    'plan_id': 52,
    'plan_name': 'Безлімітне розміщення вакансій (12 місяців)',
    'amount': 191040,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Years',
    'slug': 'bezlimitne-rozmishtennia-vakansij-12-misiaciv',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 1 р.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 р.',
      },
    ],
  },
  {
    'plan_id': 53,
    'plan_name': 'Безліміт вакансій з бренд сторінкою (12_місяців)',
    'amount': 237540,
    'currency': 'UAH',
    'plan_type': 1,
    'plan_type_value': 'Years',
    'slug': 'bezlimit-vakansij-z-brend-storinkoyu-12-misiaciv',
    'planuser': 'employer',
    'is_plan_active': 0,
    'features': [
      {
        'outer': '<b>Необмежено</b> Публ. вакансій',
        'inner': 'Ви можете публікувати Необмежено вакансій за 1 р.',
      },
      {
        'outer': '<b>50 000</b> Завантаж. резюме',
        'inner': 'Ви можете завантажити 50 000 резюме з цим планом за 1 р.',
      },
    ],
  },
];
